import { setOptions, importLibrary } from "@googlemaps/js-api-loader";
import type { Scope } from "@sentry/browser";

declare global {
    interface Window {
        Sentry: typeof import('@sentry/browser')
    }
}

setOptions({
    key: process.env.GOOGLE_MAPS_KEY
})

const googleMapElement = document.getElementById('google-map');

if (googleMapElement) {

    (async () => {

        const [{ Map }, { AdvancedMarkerElement }] = await Promise.all([
            importLibrary('maps'),
            importLibrary('marker'),
        ]) as [google.maps.MapsLibrary, google.maps.MarkerLibrary];

        const address = googleMapElement.dataset.address;
        const lat = parseFloat(googleMapElement.dataset.latitude);
        const lng = parseFloat(googleMapElement.dataset.longitude);

        const options = {
            center: new google.maps.LatLng(39.8090881, -98.5658657),
            zoom: 6,
            mapTypeId: google.maps.MapTypeId.TERRAIN,
            gestureHandling: 'none',
            mapTypeControl: false,
            fullscreenControl: false,
            keyboardShortcuts: false,
            streetViewControl: false,
            zoomControl: false,
            mapId: process.env.GOOGLE_MAPS_ID,
        } as google.maps.MapOptions;

        if (lat && lng) {
            options.center = new google.maps.LatLng(lat, lng)
        }

        const map = new Map(googleMapElement, options);

        if (lat && lng) {
            new AdvancedMarkerElement({ map, position: { lat, lng } })
        } else if (address) {
            const { Geocoder } = await google.maps.importLibrary('geocoding') as google.maps.GeocodingLibrary;
            new Geocoder().geocode({ address }).then((response) => {
                map.setCenter(response.results[0].geometry.location);
                new AdvancedMarkerElement({ map, position: response.results[0].geometry.location });
            }).catch((error) => {
                if (error.code !== 'ZERO_RESULTS') {
                    window.Sentry.withScope((scope: Scope) => {
                        scope.setTag('google', 'geocoder')
                        window.Sentry.captureException(error);
                    })
                }
            });
        }
    })()
}